import React, { useEffect, useState } from "react";
import CountrySelect from "./components/ui/CountrySelect";
import LogoEcole229 from "./assets/images/logo-white.png";
import Header from "./assets/images/header_banner.png";
import LogoBlolab from "./assets/images/logo-blolab-Version-Nette-blanc.png";
import LogoReffao from "./assets/images/logo_reffao_log_blanc.png";
import LogoMakeAfrica from "./assets/images/logo_makeafrica-blanche.png";
import PictureOne from "./assets/images/picture_one.jpg";
import PictureTwo from "./assets/images/makeafricapicture.jpeg";
import PictureThree from "./assets/images/picture_three.jpg";
import {
  checkReferer,
  getOptionsByActivity,
  getSingleActivity,
  postOrder,
  postPayment,
} from "./services/DataService";
import toast, { Toaster } from "react-hot-toast";

declare global {
  interface Window {
    FedaPay: any;
  }
}

type Formula = {
  id: number;
  name: string;
  code: string;
  description: string;
  price: number;
  activity_id: number;
};

type FormErrors = {
  firstname?: string;
  lastname?: string;
  email?: string;
  phoneNumber?: string;
  countryName?: string;
};

const App: React.FC = () => {
  const [selected, setSelected] = useState<number[]>([]);
  const [showModal, setShowModal] = useState(false);
  const [formulas, setFormulas] = useState<Formula[]>([]);
  const [loading, setLoading] = useState<boolean>(false); // pour API
  const [paymentLoading, setPaymentLoading] = useState<boolean>(false);
  const [errors, setErrors] = useState<FormErrors>({});

  const [code, setCode] = useState("");

  const validateField = (name: string, value: string) => {
    let error = "";

    switch (name) {
      case "firstname":
        if (!value) error = "Le prénom est requis";
        break;
      case "lastname":
        if (!value) error = "Le nom est requis";
        break;
      case "email":
        if (!value) error = "L'email est requis";
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value))
          error = "Email invalide";
        break;
      case "phoneNumber":
        if (!value) error = "Le numéro de téléphone est requis";
        else if (!/^\+?\d{8,15}$/.test(value))
          error = "Numéro de téléphone invalide";
        break;
      case "countryName":
        if (!value) error = "Le pays est requis";
        break;
      default:
        break;
    }

    setErrors((prev) => ({ ...prev, [name]: error }));
  };

  useEffect(() => {
    setLoading(true);

    getOptionsByActivity()
      .then((response) => {
        setFormulas(response.data);
        console.log("Formulas fetched:", response.data);
      })
      .catch((error) => {
        console.error("Error fetching options:", error);
      })
      .finally(() => setLoading(false));

    getSingleActivity()
      .then((res) => {})
      .catch((err) => {});
  }, []);

  // Form state
  const [form, setForm] = useState({
    firstname: "",
    lastname: "",
    email: "",
    phoneNumber: "",
    countryName: "",
    countryIso: "",
  });

  const handleSelect = (id: number) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((f) => f !== id) : [...prev, id]
    );
  };
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("ref")) {
      setSelected([4]);
      setCode(params.get("ref") || "");
    }
  }, []);

  const total = formulas
    .filter((f) => selected.includes(f.id))
    .reduce((sum, f) => Number(sum) + Number(f.price), 0);

  const initOrder = async () => {
    setPaymentLoading(true);
    const hasGL = formulas
      ?.filter((f) => selected.includes(f.id))
      ?.some((f) => f.code === "GL");

    postOrder({ ...form, activity_id: 1, options: selected, code })
      .then((response) => {
        const order = response.data;
        console.log("Order created:", response.data);
        const FedaPay: any = window["FedaPay"];
        FedaPay.init({
          public_key: process.env.REACT_APP_PUBLIC_KEY,
          transaction: {
            amount: total,
            description:
              "Achat Billet " + hasGL && selected.length === 1
                ? "CERTIFICATION DE LA 4e PROMOTION DE L'ECOLE229"
                : "MAKEAFRICA2025",
          },
          customer: {
            firstname: form.firstname,
            lastname: form.lastname,
            email: form.email,
          },
          currency: {
            iso: "XOF",
          },
          onComplete: async ({ reason, transaction }: any) => {
            console.log(reason, transaction);
            if (reason === "CHECKOUT COMPLETE") {
              if (transaction.status == "approved") {
                await finaliseOrder(order.id, transaction.id);
              }
            } else {
              toast.error(
                "Transaction échouée. Réessayez ou contactez le support au +2290162191935."
              );
              setPaymentLoading(false);
            }
          },
          /* onCancel: () => {
            toast.error("Transaction annulée.");
            setPaymentLoading(false);
          },
          onError: (error: any) => {
            console.error("Payment error:", error);
            toast.error("Erreur de paiement. Veuillez réessayer.");
            setPaymentLoading(false);
          } */
        }).open();
      })
      .catch((error) => {
        toast.error("Erreur lors de l'initialisation de votre commande.");
        setPaymentLoading(false);
      });
  };
  const finaliseOrder = async (orderId: number, transactionId: string) => {
    postPayment({
      transaction_id: transactionId,
      order_id: orderId,
    })
      .then((response) => {
        console.log("Payment successful:", response.data);
        setShowModal(false);
        setForm({
          firstname: "",
          lastname: "",
          email: "",
          phoneNumber: "",
          countryName: "",
          countryIso: "",
        });
        setSelected([]);
        toast.success("Votre paiement a été enregistrée avec succès !");
        setPaymentLoading(false);
      })
      .catch((error) => {
        setPaymentLoading(false);
        toast.error(
          "Erreur lors de la finalisation de votre paiement. Veuillez contactez le support au +2290162191935."
        );
      });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    // Validation globale
    let hasError = false;
    Object.entries(form).forEach(([key, value]) => {
      validateField(key, value);
      if (!value || errors[key as keyof FormErrors]) {
        hasError = true;
      }
    });

    if (hasError) {
      toast.error("Veuillez corriger les champs en rouge");
      return;
    }

    await initOrder();
  };

  const beginOrder = () => {
    if (code) {
      setPaymentLoading(true);
      checkReferer({ code })
        .then(() => {
          setPaymentLoading(false);
          setShowModal(true);
        })
        .catch(() => {
          setPaymentLoading(false);
          toast.error("Ce code de parrainage n'est pas valide");
        });
    } else {
      setShowModal(true);
    }
  };

  return (
    <div
      className="min-h-screen overflow-x-hidden"
      style={{
        background: "linear-gradient(90deg, #001041 0%, #25588d 100%)",
      }}
    >
      {/* Toast provider */}
      <Toaster position="top-right" />
      <div
        className="relative text-white"
        style={{
          background: "linear-gradient(90deg, #001041 0%, #25588d 100%)",
        }}
      >
        {/* Navbar */}
        {/*         <nav className="flex justify-between items-center max-w-7xl mx-auto px-6 py-4">
         */}
        <nav className="flex justify-between items-center max-w-7xl mx-auto">
          {/* Logo */}
          <div className="flex items-center justify-start">
            <img
              src={Header}
              alt="Logo Blolab"
              className="h-auto md:h-40 w-auto"
            />
          </div>

          {/* Bouton login */}
          <button className="hidden md:block border border-white rounded-full px-5 py-1 hover:bg-white hover:text-purple-600 transition">
            <a href="#formules"> Prendre mon billet</a>
          </button>
        </nav>

        {/* Section Hero */}
        <div className="grid md:grid-cols-2 items-center max-w-7xl mx-auto px-6 py-12 gap-8">
          {/* Texte */}
          <div className="space-y-6">
            <h1
              className="text-center md:text-justify text-4xl md:text-5xl font-extrabold"
              style={{ lineHeight: "3.5rem" }}
            >
              Billeterie MAKEAFRICA 2025 X CERTIFICATION ECOLE229
            </h1>
            <p className="text-lg text-gray-100 max-w-lg text-justify sm:mx-auto md:mx-0">
              Participez au grand festival africain de l'innovation, de la
              science et de l'éducation. MakeAfrica, initié par BloLAB et
              co-organisé avec le ReFFAO, réunit inventeurs, créateurs,
              passionnés et curieux autour de stands, ateliers et conférences
              célébrant l'esprit <em>Do It Yourself</em> et la culture Maker.
            </p>
            <p className="text-lg text-gray-100 max-w-lg text-justify  sm:mx-auto md:mx-0">
              En parallèle, vivez, le samedi soir, la cérémonie de certification
              de la 4ᵉ promotion des apprenants de l’École229, un moment fort
              mettant en lumière les nouveaux talents formés aux métiers du
              numérique et de l’innovation.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 sm:gap-6  sm:mx-auto sm:justify-center md:justify-start ">
              <button className="bg-pink-600 px-6 py-2 rounded-full font-semibold hover:bg-pink-700 w-full sm:w-auto">
                <a href="#formules"> Prendre un Ticket</a>
              </button>
              <button className="border border-white px-6 py-2 rounded-full font-semibold hover:bg-white hover:text-purple-600 w-full sm:w-auto">
                <a href="#formules">Découvrir les Formules</a>
              </button>
            </div>
          </div>
          <div className="relative mt-10 md:mt-0 flex justify-center">
            <div className="flex flex-col items-center gap-6 md:hidden">
              <img
                src={PictureOne}
                alt="Festival"
                className="w-auto rounded-xl shadow-xl"
              />
              <img
                src={PictureTwo}
                alt="Certification"
                className="w-auto rounded-xl shadow-xl"
              />
            </div>
            <div className="hidden md:flex relative justify-center items-center gap-6">
              <img
                src={PictureTwo}
                alt="Certification"
                className="w-56 md:w-auto lg:w-80 h-72 md:h-80 object-cover rounded-2xl shadow-xl transform rotate-[-5deg]"

                // className="w-64 md:w-80 h-80 object-cover rounded-2xl shadow-xl transform rotate-[-5deg]"
              />
              {/* Image 2 */}
              <img
                src={PictureOne}
                alt="Innovation"
                className="w-56 md:hidden lg:block lg:w-80 h-72 md:h-80 object-cover rounded-2xl shadow-xl transform rotate-[8deg]"

                //className="w-64 md:w-80 h-80 object-cover rounded-2xl shadow-xl transform rotate-[8deg]"
              />
            </div>
          </div>
        </div>
      </div>
      {/* Formules */}
      <div className="p-2 mt-6">
        <h2 className="text-5xl text-white font-bold text-center mb-3">
          Créez votre propre package
        </h2>
        <p className="text-center text-xl text-white mb-1">
          Rejoignez-nous pour un évènement unique avec plusieurs formules
          disponibles.
        </p>
      </div>
      <div className="max-w-4xl mx-auto bg-gray-50 p-8 rounded-2xl shadow-lg my-10">
        {/* Liste des formules */}
        {loading ? (
          <p className="text-center text-gray-500">
            Chargement des formules...
          </p>
        ) : (
          <div className="grid md:grid-cols-2 gap-6" id="formules">
            {formulas.map((f) => (
              <div
                key={f.id}
                className={`border rounded-2xl p-6 shadow-sm transition hover:shadow-lg ${
                  selected.includes(f.id)
                    ? "border-blue-600 bg-blue-50"
                    : "border-gray-200 bg-white"
                } cursor-pointer`}
                onClick={() => {
                  handleSelect(f.id);
                }}
              >
                <div className="flex items-start gap-3">
                  <input
                    type="checkbox"
                    checked={selected.includes(f.id)}
                      onClick={(e) => e.stopPropagation()}           // <- IMPORTANT
                    onChange={(e) => {
                      e.stopPropagation();
                      handleSelect(f.id);
                    }}
                    className="mt-1 h-5 w-5 accent-blue-600"
                  />
                  <div className="flex flex-col">
                    <h3 className="text-xl font-bold text-gray-900">
                      {f.name}
                    </h3>
                    <p
                      className="text-gray-500 text-sm mb-3"
                      style={{ whiteSpace: "pre-line" }}
                    >
                      {f.description
                        .replace(/\\n/g, "\n")
                        .split("\n")
                        .map((line, index) => (
                          <React.Fragment key={index}>
                            {line}
                            <br />
                          </React.Fragment>
                        ))}
                    </p>
                    <span className="text-2xl font-extrabold text-blue-600">
                      {Number(f.price).toLocaleString("fr-Fr", {
                        maximumFractionDigits: 0,
                        useGrouping: true,
                      })}{" "}
                      FCFA
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        <div className="flex flex-col mt-10 bg-white border rounded-xl p-6 shadow-sm">
          <label className="mb-1 text-gray-700 font-medium">
            Code de Parrainage{" "}
            <span className="text-gray-600">(Optionnel)</span>
          </label>
          <input
            type="text"
            placeholder="Ex: AH65VG784"
            value={code}
            onChange={(e) => {
              setCode(e.target.value);
            }}
            className={`w-full p-3 rounded-lg shadow-sm border border-gray-300
            focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition`}
          />
        </div>

        {/* Résumé + bouton */}
        <div className="flex flex-col md:flex-row items-center justify-between mt-10 bg-white border rounded-xl p-6 shadow-sm">
          <span className="text-xl font-bold text-gray-800">
            Total :{" "}
            <span className="text-blue-600">{total.toLocaleString()} FCFA</span>
          </span>
          <button
            disabled={total === 0 || paymentLoading}
            onClick={beginOrder}
            className="mt-4 md:mt-0 bg-blue-600 text-white px-6 py-3 rounded-xl font-semibold shadow-md hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed"
          >
            {paymentLoading ? (
              <span className="animate-spin border-2 border-white border-t-transparent rounded-full w-5 h-5"></span>
            ) : (
              "Passer au paiement"
            )}
          </button>
        </div>
      </div>
      {/* Modal de paiement */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl px-6 py-10 w-full max-w-2xl relative">
            <div
              className="flex items-center bg-blue-100 border-l-4 border-blue-500 text-blue-700 px-4 py-3 mb-4"
              role="alert"
            >
              <svg
                className="w-6 h-6 mr-2 flex-shrink-0"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 9v2m0 4h.01M4.93 19h14.14a1 1 0 0 0 .95-1.32l-7.07-12.73a1 1 0 0 0-1.76 0L3.98 17.68A1 1 0 0 0 4.93 19z"
                />
              </svg>

              <div>
                <h4 className="font-bold text-sm md:text-base">Attention !</h4>
                <p className="text-sm md:text-base">
                  Une seule commande par personne est autorisée par évènement.
                  Merci de vérifier vos informations avant de procéder au
                  paiement.
                </p>
              </div>
            </div>
            <button
              className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 text-lg font-bold"
              onClick={() => setShowModal(false)}
            >
              ✖
            </button>
            <h2 className="text-2xl font-bold mb-6 text-gray-800">
              Informations Personnelles
            </h2>
            <form onSubmit={handleSubmit} className="space-y-5" noValidate>
              {/** Prénom */}
              <div className="flex flex-col">
                <label className="mb-1 text-gray-700 font-medium">Prénom</label>
                <input
                  type="text"
                  placeholder="Votre prénom"
                  value={form.firstname}
                  onChange={(e) => {
                    setForm({ ...form, firstname: e.target.value });
                    validateField("firstname", e.target.value);
                  }}
                  className={`w-full p-3 rounded-lg shadow-sm border ${
                    errors.firstname ? "border-red-500" : "border-gray-300"
                  } focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition`}
                />
                {errors.firstname && (
                  <span className="text-red-500 text-sm mt-1">
                    {errors.firstname}
                  </span>
                )}
              </div>

              {/** Nom */}
              <div className="flex flex-col">
                <label className="mb-1 text-gray-700 font-medium">Nom</label>
                <input
                  type="text"
                  placeholder="Votre nom"
                  value={form.lastname}
                  onChange={(e) => {
                    setForm({ ...form, lastname: e.target.value });
                    validateField("lastname", e.target.value);
                  }}
                  className={`w-full p-3 rounded-lg shadow-sm border ${
                    errors.lastname ? "border-red-500" : "border-gray-300"
                  } focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition`}
                />
                {errors.lastname && (
                  <span className="text-red-500 text-sm mt-1">
                    {errors.lastname}
                  </span>
                )}
              </div>

              {/** Email */}
              <div className="flex flex-col">
                <label className="mb-1 text-gray-700 font-medium">Email</label>
                <input
                  type="email"
                  placeholder="Votre email"
                  value={form.email}
                  onChange={(e) => {
                    setForm({ ...form, email: e.target.value });
                    validateField("email", e.target.value);
                  }}
                  className={`w-full p-3 rounded-lg shadow-sm border ${
                    errors.email ? "border-red-500" : "border-gray-300"
                  } focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition`}
                />
                {errors.email && (
                  <span className="text-red-500 text-sm mt-1">
                    {errors.email}
                  </span>
                )}
              </div>

              {/** Téléphone */}
              <div className="flex flex-col">
                <label className="mb-1 text-gray-700 font-medium">
                  Téléphone
                </label>
                <input
                  type="tel"
                  placeholder="Votre téléphone"
                  value={form.phoneNumber}
                  onChange={(e) => {
                    setForm({ ...form, phoneNumber: e.target.value });
                    validateField("phoneNumber", e.target.value);
                  }}
                  className={`w-full p-3 rounded-lg shadow-sm border ${
                    errors.phoneNumber ? "border-red-500" : "border-gray-300"
                  } focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition`}
                />
                {errors.phoneNumber && (
                  <span className="text-red-500 text-sm mt-1">
                    {errors.phoneNumber}
                  </span>
                )}
              </div>

              {/** Pays */}
              <div className="flex flex-col">
                <label className="mb-1 text-gray-700 font-medium">Pays</label>
                <CountrySelect
                  onChange={(country) => {
                    setForm({
                      ...form,
                      countryName: country.label,
                      countryIso: country.value,
                    });
                    validateField("countryName", country.label);
                  }}
                  /*  className={`shadow-sm rounded-lg border ${
                    errors.countryName ? "border-red-500" : "border-gray-300"
                  } focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition`} */
                />
                {errors.countryName && (
                  <span className="text-red-500 text-sm mt-1">
                    {errors.countryName}
                  </span>
                )}
              </div>

              {/** Bouton de soumission */}
              <button
                type="submit"
                disabled={paymentLoading}
                className="w-full py-3 bg-blue-600 text-white rounded-lg shadow-md hover:bg-blue-700 transition flex items-center justify-center"
              >
                {paymentLoading ? (
                  <span className="animate-spin border-2 border-white border-t-transparent rounded-full w-5 h-5"></span>
                ) : (
                  "Confirmer la commande"
                )}
              </button>
            </form>
          </div>
        </div>
      )}
      <footer className="w-full bg-gray-900 text-white text-sm py-5 text-center">
        <p>
          © {new Date().getFullYear()} Blolab. Tous droits réservés.{" "}
          <span>Contact: +2290162191935.</span>{" "}
        </p>
      </footer>
    </div>
  );
};

export default App;
